// extracted by mini-css-extract-plugin
export default {"title":"Search_title__3stW1"};